import api from './api';

export const userService = {
  /**
   * Récupérer tous les utilisateurs (Admin uniquement)
   * @param {Object} filters - { role, page, limit }
   * @returns {Promise}
   */
  getAllUsers: async (filters = {}) => {
    try {
      const response = await api.get('/users', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs:', error);
      throw error;
    }
  },

  /**
   * Récupérer un utilisateur par ID (Admin uniquement)
   * @param {string} id
   * @returns {Promise}
   */
  getUserById: async (id) => {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'utilisateur:', error);
      throw error;
    }
  },

  /**
   * Créer un utilisateur (Admin uniquement)
   * @param {Object} data - Données de l'utilisateur
   * @returns {Promise}
   */
  createUser: async (data) => {
    try {
      const response = await api.post('/users', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de l\'utilisateur:', error);
      throw error;
    }
  },

  /**
   * Mettre à jour un utilisateur (Admin uniquement)
   * @param {string} id
   * @param {Object} data
   * @returns {Promise}
   */
  updateUser: async (id, data) => {
    try {
      const response = await api.patch(`/users/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'utilisateur:', error);
      throw error;
    }
  },

  /**
   * Supprimer un utilisateur (Admin uniquement)
   * @param {string} id
   * @returns {Promise}
   */
  deleteUser: async (id) => {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'utilisateur:', error);
      throw error;
    }
  },
};

export default userService;
